import 'core-js'
import 'regenerator-runtime/runtime'

import 'bootstrap/dist/css/bootstrap.css';
import 'billboard.js/dist/billboard.css';
import '../styles/main.css';
import '../styles/icons.css';
import '../styles/social.css';
import '../styles/pub_specific.css';

import 'bootstrap-select-v4';
import bootStrapCss from '../../node_modules/bootstrap-select-v4/dist/css/bootstrap-select.min.css';
import dropdowncss from '../styles/dropdown.css';

const appData = require('../../../configs/' + project + '/' + appid+'/indicator.js');
const configFile = require ('../../../configs/configuration.js')
const constants = configFile.configuration.data;


import 'jquery-csv';

window.data = configFile;
window.currentId = appid;
window.indicators = appData.visData;

import * as d3 from "d3";
import {
    library,
    dom
} from '@fortawesome/fontawesome-svg-core';
import {
    faTwitter,
    faFacebookF
} from '@fortawesome/free-brands-svg-icons';
import {
    faSquare as faSolidSquare,
    faCircle,
    faShareAlt,
    faSpinner,
    faInfo,
    faCode,
    faCheck,
    faSortUp,
    faSortDown,
    faSort,

} from '@fortawesome/free-solid-svg-icons';

import {
    faSquare as faRegularSquare,
    faCheckSquare
} from '@fortawesome/free-regular-svg-icons';

import {
    _,
    localizeHTMLTag,
    getParameterValue,
    translateAll
} from './lang';
import {
    bb
} from 'billboard.js';
import createSocial from './components/social';
import {
    setupLocalisation,
    localiseInterface
} from './localizeservice';
import requestData from './dataservice';

import {
    storage
} from './storage';
import {
    isIE,
    nbOfDavaAvailableForCountries,
    roundValue,
    compare,
    inIframe,
    TestClass,
    isMobile
} from './components/utils';
import {
    createIndSelectionCheckBoxes,
    createIndSelectionBigIcons,
    createIndSelectionSelectbox,
    buildCustomList,
    checkSortIcons,
    applySort

} from './components/ui-component';

library.add(faTwitter, faFacebookF, faCircle, faSolidSquare, faRegularSquare, faShareAlt, faSpinner, faInfo, faCode, faCheck, faCheckSquare, faSortUp, faSortDown, faSort);

const CHECKED_FA_HTML = '<span class="fa-layers"><i class="fas fa-square" data-fa-transform="grow-8"></i><i class="fas fa-check fa-inverse" data-fa-transform="shrink-2"></i></span>';
const UNCHECKED_FA_HTML = '<span class="fa-layers"><i class="far fa-square" style="color:grey" data-fa-transform="grow-8"></i></span>';

/*

var defaultAppId = "eumove_01_01_01";
var appId = getParameterValue("id") == "" ? defaultAppId : getParameterValue("id");

var appsId = Object.keys(window.appData);
var currentId = defaultAppId;

var urlPaths = window.location.href.split("/");
var urlLastFolder = urlPaths[urlPaths.length - 2];
urlLastFolder = urlLastFolder.replace("DIR_", "");

if (getParameterValue("id") != "" && inIframe() == false) {
    currentId = getParameterValue("id");
} else if (appsId.indexOf(urlLastFolder) != -1) {
    currentId = urlLastFolder;
}


window.currentId = currentId;
window.indicators = window.appData[currentId];
*/

var config = configFile.configuration;

let chart;
var UIComponentHeight;
var groupsNames = [];
var groups = [];
var groupsMapping = [];
var groupsColors = {};
var groupsTypes = {};
var dataColors;
var color;
let displayed;
var data;
var dataNotCorrected;
var arrayNotCorrected;
var arrayGrouped;
var dataColumns;
var countries = [];
var countriesCodes = [];
var arrayNoData = [];
var currentCategory = 0;
var currentSorting = "";
var selectedCountry = (getParameterValue("country") != "" && getParameterValue("country") != null) ? getParameterValue("country") : "";
let selectedSortProperty = config.defaultSortProperty
let selectedSortDirection = config.defaultSortDirection
let hide = groups;
let legendItems;
let legendContent;
let legendHide = true;
var rtime;
var timeout = false;
var delta = 100;
var indexDataToNotTouch = null;
var dataFile = [];
var dataFileFiltered = [];
var simpleMode = indicators[currentCategory].disregardSimpleMode != null ? false : (getParameterValue("simple") != null && getParameterValue("simple") === "true");

$(window).resize(function() {
    rtime = new Date();
    if (timeout === false) {
        timeout = true;
        setTimeout(resizeend, delta);
    }
});

function resizeend() {
    if (new Date() - rtime < delta) {
        setTimeout(resizeend, delta);
    } else {
        timeout = false;
       // alert('Done resizing');
	   resize();
    }               
}
d3.selection.prototype.moveToBack = function() {  
    return this.each(function() { 
        var firstChild = this.parentNode.firstChild; 
        if (firstChild) { 
            this.parentNode.insertBefore(this, firstChild); 
        } 
    });
};
window.onorientationchange = function() {
    setTimeout(resizeend, 200);
};

function resize() {
    if (indicators[currentCategory].chartType == "scatter") {
        //return;
    }
    $("#chart").html("");
    init();
}
function addNSILogo () {
    if (_("imgYourLogo").length > 0) {
        var img = _("imgYourLogo");
        var height = $("#estatLogo").height() *0.6;
        $("#nsiConteiner").html(img);
        $("#nsiConteiner img").css("height", height);
    }else {
        $("#logo-desktop").attr("href", "");   
    }
}
$(function() {
    dom.watch();
    $('#logo-desktop').click(function(e) {
        e.preventDefault();
        //do other stuff when a click happens
    });
    // config.searchPseudoElements = true;

    if (indicators[currentCategory].displaySharing != "always" &&  simpleMode) {
        $("#navbar, #icons-container").hide();
    }
    if (indicators[currentCategory].displayCookieConsent && indicators[currentCategory].displayCookieConsent == true) {
        $("#cookies-link").show();
    }


    setupLocalisation();
    addNSILogo();
    translateAll();
    document.title = _("document.title");
    initDefaultValues();
    var callback = function () {
        $("#loader").hide();
        window.categorySelected = 0;
        localiseInterface();

        if (indicators[currentCategory].UISelectInd == "Icons") {
            createIndSelectionBigIcons();
        } else if (indicators[currentCategory].UISelectInd == "Select") {
            createIndSelectionSelectbox();
        } else {
            createIndSelectionCheckBoxes();
        }
        createSocial()
        processData(currentCategory, currentSorting);
    };
    if (indicators[currentCategory].dataType == "file") { 
        loadDataFromFile(function () {
            callback();
        });
    } else {
        jQuery.when(requestData(0)).done(function() {
            callback();
        }).fail(function(error) {
            console.log('error while retrieving data', error);
        });
    }
    buildCustomList();

});

function loadDataFromFile (callback) {

    $.ajax({
        type: "GET",  
        url: "data/data.csv",
        dataType: "text",       
        success: function(response)  
        {
            dataFile = $.csv.toObjects(response, {"separator" : ";"});
            callback();

        }   
      });
}

function filterDataFile (filterKey, filterValue) {
    var dataTmp =  dataFile.filter(function(el) { return el[filterKey] == filterValue });
    var allKeyValue = indicators[currentCategory].grouping.groups.map( function( value ) {return value.code});

     dataFileFiltered = dataTmp.map( function( value ) {
        delete(value.Total);

        if (value[allKeyValue[0]] != "z" && value[allKeyValue[0]] != NaN) {
            value.Total = 100;
         }else if (indicators[currentCategory].chartType == "scatter") {
            value.Total = 100;
         }
         for (var i = 0; i < allKeyValue.length; i++) {
            var key = allKeyValue[i];
            var valueTmp = value[key];

            if (valueTmp && typeof valueTmp == "string" &&  valueTmp.indexOf(",") !== -1) {
                valueTmp = valueTmp.replace(",",".");
            }
  
            if (valueTmp == "z" && indicators[currentCategory].chartType == "scatter") {
                valueTmp = 0;
    
            }else {
          
            }
  
            value[key] = valueTmp;
         }
        return value;
    });
    
    return dataFileFiltered;

}

function changeParams(paramName, value) {
    for (var indicatorIndex in indicators) {
        var indicator = indicators[indicatorIndex];
        var params = indicator.params;
        for (var key in params) {
            const param = params[key];
            if (key == paramName) {
                param.selected = value;
            }
        }
    }

}



function initDefaultValues() {
    groupsNames = [];
    groupsColors = {};
    groups = [];

    var params = indicators[currentCategory].params;
    for (var paramKey in params) {
        var param = params[paramKey];
        if (param.items) {
            if (param.urlParam && getParameterValue(param.urlParam)) {
                changeParams(paramKey, getParameterValue(param.urlParam));
            }

        }

    }

    const grouping = indicators[currentCategory].grouping;
    currentSorting = grouping.default;

    var iterator = 1;

    // add all groups we need
    for (var group in grouping.groups) {

        var currData = "data" + iterator;

        if (grouping.groups[group].code == currentSorting) {
            selectedSortProperty = currData;
        }
        groupsMapping[grouping.groups[group].code] = currData;
        groups.push(currData);

        groupsNames[currData] = grouping.groups[group].legend ? _(grouping.groups[group].legend) : _(grouping.groups[group].title);
        groupsColors[currData] = grouping.groups[group].color;
        if (grouping.groups[group].type && grouping.groups[group].type != "bar" ) {

        }
        groupsTypes[currData] = grouping.groups[group].type ? grouping.groups[group].type : "line";     
        iterator++;
    }

    displayed = groups;

}

function initSortingCheckboxes() {

    $("#chartSort").html('<p class="sortby">							' + _("sortBy.title") + ' </p>');
    var html = '';
    const grouping = indicators[currentCategory].grouping;

    for (var group in grouping.groups) {
        var opacity = currentSorting == grouping.groups[group].code ? 'style="opacity:1"' : 'style="opacity:0.3"';
        var icon = currentSorting == grouping.groups[group].code ? CHECKED_FA_HTML : UNCHECKED_FA_HTML;
        html += '<div class="checkbox checkbox-success" id="sort' + grouping.groups[group].code + '">' + icon + '<label for="checkboxSmall">' + _(grouping.groups[group].title) + '</label></div>';

    }

    html += "";
    $("#chartSort").append(html);
    $("#chartSort ul li a").click(function() {
        var code = $(this).attr("href").replace("#", "");

        currentSorting = code;

        processData(window.categorySelected, currentSorting);
    })

    $("#chartSort div.checkbox").click(function() {
        var code = $(this).attr("id").replace("sort", "");

        currentSorting = code;

        processData(window.categorySelected, currentSorting);
    })

}


function initSortingColorBoxes() {
    $("#chartSort").html('');
    var html = '<ul>';
    const grouping = indicators[currentCategory].grouping;
    var iterator = 1;

    for (var group in grouping.groups) {
        var opacity = currentSorting == grouping.groups[group].code ? 'style="opacity:1"' : 'style="opacity:0.3"'
        html += '<li ' + opacity + ' ><a href="#' + grouping.groups[group].code + '"><div class="square" style="background-color:' + grouping.groups[group].color + '"></div>' + _(grouping.groups[group].title) + '</li></a>';
    }

    html += "</ul>";
    $("#chartSort").append(html);
    $("#chartSort ul li a").click(function() {
        var code = $(this).attr("href").replace("#", "");
        currentSorting = code;
        processData(window.categorySelected, currentSorting);
    })

}

function indicatorClick(category) {
    $("#loader").show();
    currentCategory = category;
    initDefaultValues();
    var callback = function () {
        $("#loader").hide();
        window.categorySelected = category
        const data = storage.processedData[category]
        // localise
        localiseInterface(category);
        processDataForCategory(category);

    } 
    if (indicators[category].dataType == "file") { 
        callback();
    } else {
        jQuery.when(requestData(category)).done(function() {
            callback();
        }).fail(function(error) {
            console.log('error while retrieving data', error);
        });
    }

}

function processDataForCategory(category, sort = currentSorting) {
    processData(category, sort);
}

function correctData2 (data, sort) {

    //return data;
    const grouping = indicators[currentCategory].grouping;
    let groups = grouping.groups.map(a => a.code);
    //console.log(groups);
    var groupsRemaining = groups.filter(function(el) { return el != sort }); 
    //console.log("groupsRemaining");
    //console.log(groupsRemaining);
    var dataToCorrect = groupsRemaining[0];

    data.forEach(function(item) {
        //console.log(item);
        if (item[sort +"_UNTOUCHED"]) {
            item[sort] = item[sort +"_UNTOUCHED"];
            delete item[sort +"_UNTOUCHED"];
        }
        if (item[dataToCorrect +"_UNTOUCHED"] == undefined){ 
            item[dataToCorrect +"_UNTOUCHED"] = item[dataToCorrect];

        }
        var allOtherVal = 0;// = item.filter(function(el) { console.log(el);return el != sort }); ;
        jQuery.each(item, function(name, value) {
            if (groups.indexOf(name) !== -1 && name !== dataToCorrect) {
                allOtherVal+=parseFloat(value);
            }
        });
        //console.log(item);
        item[dataToCorrect] = 100 - allOtherVal;


    })

    return data;

}

export default function processData(category, sort, direction = "desc") {
    const grouping = indicators[currentCategory].grouping;

    data = [];
    countries = [];
    countriesCodes = [];
    var array;

    if (indicators[category].dataType == "file") {
        var filterKey = indicators[category].dataFileFilter.filterKey;
        var filterValue = indicators[category].dataFileFilter.filterValue;
        array = filterDataFile(filterKey, filterValue);

    } else {
        var dataProcess = storage.processedData[category];

         array = $.map(dataProcess, function(value, index) {
            return [value];
        });
    }

    var compareCustum = compare(sort);

    var indexFrom = 0;
    arrayGrouped = [];

    arrayNoData = constants.countries;

    constants.countriesGroupped.forEach(function(arrayCountries) {

        var arrayCountriesWithoutRemove = arrayCountries;

        if (arrayCountriesWithoutRemove.length > 0) {
            var nbDataAvailable = nbOfDavaAvailableForCountries(array, arrayCountries);
            var arrayDataTmp = array.slice(indexFrom, eval(indexFrom + nbDataAvailable));

            if (typeof indicators[currentCategory].correctDataTo100 == undefined || typeof indicators[currentCategory].correctDataTo100 == "undefined" || typeof indicators[currentCategory].correctDataTo100 == true) {
                arrayDataTmp = correctData2(arrayDataTmp, sort);
            }
            var arrayDataCleaned = [];
            arrayDataTmp = arrayDataTmp.filter( function( el ) {
                return indicators[category].countries2Remove.indexOf( el.Geo ) < 0;
              } );
            arrayDataTmp.forEach(item => {
                //console.log(item);
                if (item.Total != undefined) {
                    //console.log(item);
                    arrayDataCleaned.push(item);
                    var indexCountry = arrayNoData.indexOf(item.Geo);
                    if (indexCountry > -1) {
                        arrayNoData.splice(indexCountry, 1);
                    }
                }
            });
            arrayDataCleaned = arrayDataCleaned.sort(compareCustum);
//console.log(arrayDataCleaned);
            if (direction == "asc") {
                arrayDataCleaned = arrayDataCleaned.reverse();
            }
            if (nbDataAvailable > 0) {
                arrayGrouped.push(...arrayDataCleaned);
                arrayGrouped.push([]);
                indexFrom += nbDataAvailable;
            }
        }
    });

    arrayGrouped.forEach(function(item) {
        if (item != undefined && item.Geo != undefined && item.Total != undefined) {
            var arrDataItem = [];
            for (var groupIndex in grouping.groups) {
                var code = grouping.groups[groupIndex].code;
                arrDataItem.push(item[code]);
            }
            arrDataItem.push(item.Geo);
            /*
            console.log("****************");
            console.log("Push country "+item.Geo);
            console.log(item);
            */
            data.push(arrDataItem);
            countries.push(_(item.Geo));
            countriesCodes.push(item.Geo);

        } else if (item.Geo == undefined && arrayGrouped[arrayGrouped.length-1] != item) {
            data.push([null, null, null, ""]);
            countries.push(item.Geo);
            countriesCodes.push(item.Geo);

        }

    });
    data = [groups].concat(data);
    var dataCorrectedTmp = correctData(data);
    dataNotCorrected = data.splice(0);
    data = dataCorrectedTmp;

    if (window.parent !== window && window.parent.disableCountries) {
        window.parent.disableCountries(arrayNoData)
    }

    if ($("#chart svg").length) {
        chart.destroy();
        init();
    } else {
        init();

    }
    return;
}



// Dirty fix to have all sum to 100 as some data in the dataset has 99.9 or 100.1 sum
function correctData(data, indexToNotChange = null) {
    //indexToNotChange = indexDataToNotTouch;
    //console.log("indexDataToNotTouch  = "+indexDataToNotTouch);
    var dataTmp = [];
    var iterator = 0;
    arrayNotCorrected = [];
    data.forEach(function(item) {
        var itempTmp = item.slice(0);
        var code = item[item.length - 1];
        var itempTmpSum = item.slice(0, item.length - 1);
        var sum = itempTmpSum.reduce(function(pv, cv) {
            return pv + cv;
        }, 0);

        dataTmp.push(itempTmp);
        iterator++;
    });
    return dataTmp;
}



function getDimensions() {
    const padding = 45
    var h = window.innerHeight // * 0.5 - padding,

    if ((window.orientation == 90 || window.orientation == -90) /*&& window.innerHeight < 600*/ ) {
        h = Math.max(h, 800);
    }
    // w = window.innerWidth * 0.95, //mobile!
    const w = window.innerWidth // * 0.9;
    const dim = {}
    dim.axisRotated = false
    dim.padding = 50
    dim.barwidth = window.innerHeigh > 700 ? 25 : 10;
    if (window.isMobile) {
        // Find matches
        const mql = window.matchMedia('(orientation: portrait)')

        // If there are matches, we're in portrait
        if (mql.matches) {
            // Portrait orientation
            if (w > 321 && w <= 480) {
                dim.axisRotated = true
                // h = 800;
                dim.h = h * 0.6 + 30
                dim.w = w * 0.95
            } else if (w <= 320) {
                dim.axisRotated = true
                dim.h = h * 0.57
            } else {
                // Landscape orientation
                // check also for ultrawide screens
                if (h <= 768 && w > 1200) {
                    dim.h = h * 0.45
                } else {
                    dim.h = h * 0.53
                    // dim.h = h * 0.5;

                }
            }
        }
    } else {
        if (h < 550 ) {
            dim.h = h * 0.84 - UIComponentHeight - padding;
        } else  if (h < 700 ) {
            dim.h = h * 0.80 - UIComponentHeight - padding;
        } else if (h < 1000) {
            // const padding = 30,
            // h = window.innerHeight * 0.8 - padding,
            dim.h = h * 0.843 - UIComponentHeight - padding;
            dim.h += h < 768 ? 30 : 0;
        } else {
            // const padding = 30,
            // h = window.innerHeight * 0.8 - padding,
            dim.h = h * 0.843 - UIComponentHeight - padding;
        }

        // w = window.innerWidth * 0.95, //mobile!
        dim.w = w * 0.95;

        if (window.indicators[currentCategory].publicationId === "HousingInEurope") {
            dim.w = w * 0.95;
        }
        if (isIE() && simpleMode) {
            dim.h = dim.h * 0.9;
        }
    }

    //$("#header, #titles, #chartInd, #chartFooter").hide();
    dim.h = calculateRemainingHeight();
    setTimeout(function() {
        calculateRemainingHeight();
    },2000)
    return dim
}

function calculateRemainingHeight () {
    //console.log("**************************");
    var h = $(window).height();
    var height = h;
    //console.log("Height Initial  = "+h);
    
    h -= document.getElementById("header").offsetHeight;
    //console.log("Height Header = "+document.getElementById("header").offsetHeight);
    //console.log("Height  = "+h);


    if (simpleMode) {
        var topMargin;
        if (height < 400) {
            topMargin = 10;
        }else if (height < 600){
            topMargin = 15;
        }else {
            topMargin = 20;
        }
        $("#titles").css("margin-top",topMargin+"px")
        h -= topMargin;
    }
    h -= $("#titles").height();
    //console.log("Height Titles = "+$("#titles").height());
    //console.log("Height  = "+h);

    if (simpleMode && height < 600) {
        var marginBottom = -28
        $("#chart").css("margin-bottom",marginBottom+"px")
        h -= marginBottom;

        var marginTop = -7
        $("#chart").css("margin-top",marginTop+"px")
        h -= marginTop;
    }else {
        var marginBottom = -12
        $("#chart").css("margin-bottom",marginBottom+"px")
        h -= marginBottom;
    }

    h -= $("#chartSort").height();
    //console.log("Height Chart Sort = "+$("#chartSort").height());
    //console.log("Height  = "+h);

    h -= $("#chartInd").height();
    //console.log("Height Chart Ind = "+$("#chartInd").height());
    //console.log("Height  = "+h);

    if (indicators[currentCategory].UISortGroup == "checkboxSort"
    || indicators[currentCategory].UISortGroup == "checkbox") {
    var fixedLegendHeight = 40;
    h -= fixedLegendHeight;
    //console.log("Height Legend = "+fixedLegendHeight);
    //console.log("Height  = "+h);
    }

    h -= $("#chartFooter").height(); 
    //console.log("Height Footer = "+$("#chartFooter").height()); 
    //console.log("Height  = "+h); 



    //$("#header, #titles, #chartInd, #chartFooter").css("background-color","red");
    //$("#chart").css("background-color","blue");
    $("#chartSort").css("margin","unset");
    
   // $("#dummy").hide();

    return h;
}


function init() {
    hide = groups;
    hide = hide.filter(displayedCat => {
        return !displayed.includes(displayedCat)

    })
    $("#logo").show();
    UIComponentHeight = 43;
    if (simpleMode) {
        UIComponentHeight -= 60;
    }
    $("html").addClass(indicators[currentCategory].publicationId);
    if (indicators[currentCategory].usePatterns == true) {
        dataColors = function(color, d) {
            if (d.index != undefined) {
                var dataRow = data[d.index + 1];
                var code = dataRow[dataRow.length - 1];
                if (code == selectedCountry) {
                    var groupIndex = groups.indexOf(d.id);
                    return "url(#pattern" + groupIndex + ")";
                } else {
                    return groupsColors[d.id];
                }
            } else if (groupsColors[d]) {
                return groupsColors[d];
            }
        };
        color = {
            pattern: ["#1f77b4", "#aec7e8"],
            // Set colors' patterns;
            // it should return an array of SVGPatternElement
            tiles: function() {
                var patterns = [];

                for (var groupIndex in groups) {
                    var group = groups[groupIndex];

                    var pattern = document.createElementNS("http://www.w3.org/2000/svg", "pattern");
                    var rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");

                    pattern.setAttribute("patternUnits", "userSpaceOnUse");
                    pattern.setAttribute("patternTransform", "rotate(30)");
                    pattern.setAttribute("id", "pattern" + group);
                    pattern.setAttribute("id2", "pattern" + groupIndex);
                    pattern.setAttribute("x", "0");
                    pattern.setAttribute("y", "0");
                    pattern.setAttribute("width", "8");
                    pattern.setAttribute("height", "8");
                    pattern.setAttribute("fill", "none");

                    rect.setAttribute("x", "0");
                    rect.setAttribute("y", "0");
                    rect.setAttribute("width", "6");
                    rect.setAttribute("height", "8");
                    rect.setAttribute("style", "stroke:none;fill:" + groupsColors[group]);

                    pattern.appendChild(rect);

                    patterns.push(pattern);
                }
                return patterns;

            },

            // for threshold usage, pattern values should be set for each steps
            pattern: ["none", "none", "none", "none", "none"],

            // will pass data object to the callback
            onover: function(d) {
                return "pattern1";
                var dataRow = data[d.index + 1];

                var code = dataRow[dataRow.length - 1];
                if (code == selectedCountry) {
                    return;
                } else {
                    //return "blue";

                    return "pattern1";
                    return d.id === "data1" ? "#f26522" : "#f26522";
                }
            }
        };
    } else {
        dataColors = groupsColors;
        color = groupsColors;
        dataColors = function(color, d) {
            if (d.id) {
                return groupsColors[d.id];
            } else {
                return groupsColors[d];
            }

        }
    }

    if (indicators[currentCategory].UISortGroup == "checkbox") {
        initSortingCheckboxes();

        legendItems = {
            onclick: function(id) {},
            onover: function(id) {},
            onout: function(id) {}
        };
        legendHide = false;
        legendContent = {
            bindto: '#legend',
            template: function(title, color, data) {
                if (title == "undefined") {
                    return "";
                }

                return (

                    "<div class='noAction legend-wrapper' style='display:inline-block; margin-right: 16px;'><div id='checkbox-" +

                    title +

                    "' style='display:inline-block; color: black; margin-right: 8px'></div><div class='square' style='background-color:" +

                    color +

                    ";padding:4px; display:inline-block;'></div><span style='margin-left: 3px; color: black;font-size:10px;'>" +

                    groupsNames[title] +

                    "</span><span class='sort' style='display:inline-block; margin-left: 6px;' title='" +

                    _('sort.hover') +

                    "' id='sort_" +

                    title +

                    "'></span></div>"

                )

            }

        };

    } else if (indicators[currentCategory].UISortGroup == "checkboxSort") {
        legendItems = {
            onclick: function(id) {
                // we only hide, if at least one series will stay active
                if (displayed.includes(id) && displayed.length > 1) {
                    displayed = displayed.filter(function(curId) {
                        return curId !== id
                    })
                    chart.hide(id)
                } else if (!displayed.includes(id)) {
                    displayed.push(id)
                    chart.show(id)
                }
    
                if (displayed.length == 1) {
                    var dataDisplayed = displayed[0];
                    var idDisplayed = parseInt(dataDisplayed.replace("data","")) - 1;
                    var iterator = 0;
                    //console.log("not touched = "+dataDisplayed+"  index = "+idDisplayed);
                    indexDataToNotTouch = idDisplayed;

                }else {
                    indexDataToNotTouch = null;

                }
                processData(window.categorySelected, currentSorting, selectedSortDirection);
                checkSortIcons(selectedSortProperty, selectedSortDirection);

                //drawScatterLines();
                
            }

        };
        legendContent = {
            bindto: '#legend',
            template: function(title, color, data) {
                if (title == "undefined") {
                    return "";
                }

                let checkboxIcon = 'fa-check-square'

                if (!displayed.includes(title)) {

                    checkboxIcon = 'fa-square'

                }
                var groups = indicators[currentCategory].grouping.groups;
                var item =  groups.find(function(el) { return el.color == color }); 
                let curSortIcon = 'fa-sort'

                if (title === selectedSortProperty || item.code == currentSorting) {
                    curSortIcon = selectedSortDirection === 'desc' ? 'fa-sort-down' : 'fa-sort-up'
                }
                curSortIcon = "fa-sort-down";
                var legendShape = item.patternInLegend != "false" && item.pattern && item.type == "line" ? '<svg class="shape"  style="stroke:'+item.color+'" fill="'+item.color+'">' + item.pattern + '</svg>' : '<span style="width: 15px;height: 15px;display: inline-block;background-color:' + item.color + '"></span>';
                //var legendShape = item.pattern  ? '<svg class="shape" style="stroke:'+item.color+'" fill="'+item.color+'">' + item.pattern + '</svg>' : "<div style='background-color:" + color + ";padding:8px; display:inline-block;'></div>";

                return (

                    "<div class='legend-wrapper' style='display:inline-block; margin-right: 16px;'><div id='checkbox-" +

                    title +

                    "' style='display:inline-block; color: black; margin-right: 8px'><i class='far " +

                    checkboxIcon +

                    " fa-2x' ></i></div>" + legendShape + "<span style='margin-left: 3px; color: black;font-size:14px;'>" +

                    groupsNames[title] +

                    "</span><span class='sort' style='display:inline-block; margin-left: 6px;' title='" +

                    _('sort.hover') +

                    "' id='sort_" +

                    title +

                    "'><i class='fas " +

                    curSortIcon +

                    " fa-2x'  data-fa-transform='shrink-1 down-1' style='color:black'></i></span></div>"

                )

            }

        };
        legendHide = "undefined";
    } else if (indicators[currentCategory].UISortGroup == "box") {
        initSortingColorBoxes();
    }

    if (indicators[currentCategory].UISelectInd && indicators[currentCategory].UISelectInd == "Icons") {
        UIComponentHeight += (69 + 10);
    } else if (indicators[currentCategory].UISelectInd && indicators[currentCategory].UISelectInd == "Select") {
        UIComponentHeight += (46 + 10);
    } else if (indicators[currentCategory].UISelectInd) {
        UIComponentHeight += 30;
    }

    // Script
    if (indicators[currentCategory].chartType == "scatter") {
        initScatterChart();
    } else {
        initChart();
    }
   // 


}

function findMinimum (data) {
    var min  = 100;
    for (var i = 0; i < data.length; i++) {
        var item = data[i];
        for (var j = 0; j < item.length -1; j++) {
            min = (item[j] < min && item[j] != 0) ? item[j] : min;
        }
    }
    return min;
}

function initScatterChart() {
    var min = indicators[currentCategory].yAxis ? indicators[currentCategory].yAxis.min :  findMinimum(data);
    var max =  indicators[currentCategory].yAxis ? indicators[currentCategory].yAxis.max : null;
    var padding = indicators[currentCategory].yAxis ? 2 : null;

    const dim = getDimensions()
    var patterns = indicators[currentCategory].grouping.groups.map(a => a.pattern)
    patterns = indicators[currentCategory].grouping.groups.filter(function(el) { return el.type != "bar" }).map(a => a.pattern);

    $("body").addClass("scatter");
        chart = bb.generate({
            size: {
                height: isMobile() ? dim.h : dim.h,
                width: dim.w
            },
            padding:{
                left:isMobile() ? 32 : null
            },
            categories:groupsNames,
            data: {
                hide:hide,
                names:Object.assign({}, groupsNames),
                rows: data,
                //type: "line", // for ESM specify as: scatter()
                types: groupsTypes,
                color: dataColors
            },
    
            axis: {
                x: {
                    type: "category",
                    categories: countries,
                    tick: {
                        centered:true,
                        rotate: 0,
                        autorotate: true,
                        multiline: false,
                        culling: false,
                        fit: true,
                        "format": function(x) {
                            // x is the datetime data
                            var code = countriesCodes[x];
                            return code == "EU27_2020" ? "EU" : code;
                        }
                      },
    
                },
                y: {
                    label: {
                        text: _("indicator"+indicators[currentCategory].code+".yAxisTitle"),
                        position: "outer-middle"
                    },
                    min:min,
                    max:max,
                    padding:padding
                 
                }
            },
            bindto: "#chart",
            point: {
                pattern:patterns
              },
              onrendered: function() {
                if (indicators[currentCategory].showVertLines != false) {
                drawScatterLines();
                }

                $("#bookmark-link, #chartInd").show();
                checkSortIcons(selectedSortProperty, selectedSortDirection);
    
                d3.selectAll("pattern").attr("id", function(d) {
                    return $(this).attr("id2");
                })
                var code = selectedCountry;
                var countryFound = false;
                d3.selectAll('g.bb-axis.bb-axis-x .tick') //here's how you get all the nodes
                    .each(function(d) {
                        // your update code here as it was in your example
                        if (d3.select(this).selectAll("tspan").text() == code) {
                            d3.select(this).selectAll("text").attr("fill", "#E34A21");
                            d3.select(this).selectAll("text").attr("font-weight", "bold");
                            countryFound = true;
                        } else {
                            d3.select(this).selectAll("text").attr("fill", "black")
                            d3.select(this).selectAll("text").attr("font-weight", "regular")
                        }
    
                    });
                if (countryFound == false && parent.displayChartAlert) {
                    parent.displayChartAlert("noData", code);
                } else {
                    //alert('Data not available');
                }
                
    
              },
              legend: {
                hide: "undefined",
              },
              tooltip: {
                order: "desc",
                format: {
                    value: function(value) {
                        return Math.round(value * 100) / 100 + _(indicators[currentCategory].grouping.unit);
                    },
                },
                contents: function(d, defaultTitleFormat, defaultValueFormat, color) {

                    if (d[0].value == null && d[1].value == null) {
                        return;
                    }
    
                    var content = '<table class="bb-tooltip"><tbody>' +
                        '<tr><th style="background-color:black" colspan="2">' + countries[d[0].index] + '</th></tr>';
                    const grouping = indicators[currentCategory].grouping;
                    var originalData = arrayGrouped[d[0].index];
                    var codes = indicators[currentCategory].grouping.tooltipOrder ? indicators[currentCategory].grouping.tooltipOrder : indicators[currentCategory].grouping.groups.map(function( n, i ) {return n.code;});;

                    for (var indexCode in codes) {

                        var code = codes[indexCode];
                        var index = parseInt(indexCode)+1;
                        var dataCode = groupsMapping[code];
                        var item = d.find(function(el) { return el.id == dataCode }); 
                       // if (item == null) {console.log("item == null");return;}
                        if (item != null && item.id != "undefined") {
                            var groupIndex = groups.indexOf(item.id);
                            var currentGroup = grouping.groups[groupIndex].code;
    
                            var code = item.code;
                            var value = roundValue(item.value, indicators[currentCategory].precision);
                            
                            if (currentGroup != currentSorting && originalData[currentGroup+"_UNTOUCHED"]) {
                                value = "Corrected";
                                value = roundValue(originalData[currentGroup+"_UNTOUCHED"],indicators[currentCategory].precision);
                            }
                            var legend = grouping.groups[groupIndex].legend ? grouping.groups[groupIndex].legend : grouping.groups[groupIndex].title;
    
                            if (value != 0) {
                                var strValue = value.toString();
                                strValue = strValue.replace(".", _("decimal_separator"));
                                var legendShape = grouping.groups[groupIndex].patternInLegend != "false" &&  grouping.groups[groupIndex].pattern && grouping.groups[groupIndex].type == "line" ? '<svg class="shape"  style="stroke:'+grouping.groups[groupIndex].color+'" fill="'+grouping.groups[groupIndex].color+'">' + grouping.groups[groupIndex].pattern + '</svg>' : '<span style="background-color:' + grouping.groups[groupIndex].color + '"></span>';
                                content += '<tr class="bb-tooltip-name-data1"><td class="name">' + legendShape + _(legend) + '</td><td class="value">' + strValue + ' ' + _(indicators[currentCategory].grouping.unit) + '</td></tr>';
    
                            }
    
    
                        }
                    }
                    content += '</tbody></table>';
                    return content;
    
                }
            },
            grid: {
                y: {
                  show: true,
                },
          },
          legend: {
            hide: legendHide,
            item: legendItems,
            contents: legendContent,
        },
          });
    
    }
    

function initChart() {
   // console.log(data);
    const dim = getDimensions()
    var barWidthRatio = dim.h < 500 ? 1.4 : 1.6;
    //console.log(data);
    chart = bb.generate({
        size: {
            height: dim.h,
            width: dim.w
        },
        padding:{
            right:11
        },
        data: {
            //columns:dataColumns,
            hide: hide,
            rows: data,
            names: groupsNames,
            labels: {
                format: function(v, id, i, j) {
                    return id == "data1" ? Math.round(v * 100) / 100 + '%' : "";
                },
                position: {
                    x: -50,
                    y: 1
                }
            },
            type: "bar",
            groups: [
                groups
            ],
            order: null,
            color: dataColors
        },
        grid: {
            y: {
                lines: [{
                    value: 0
                }]
            }
        },
        bar: {
            width: {
                ratio: barWidthRatio,
                max: 50
            },
            padding: -20

        },
        axis: {
            rotated: true,
            x: {
                type: "category",
                categories: countries,
                padding:{right:0.2},
                tick: {
                    height: 160,
                    width: 180,
                    multiline: false
                },
      

            },
            y: {
                max: 91
            }
        },
        tooltip: {
            order: "desc",
            format: {
                value: function(value) {
                    return Math.round(value * 100) / 100 + '%';
                },
            },
            contents: function(d, defaultTitleFormat, defaultValueFormat, color) {
                if (d[0].value == 0) {
                    return;
                }
                //EU27_2020_toolitp
                var countryName = countries[d[0].index];
                if (_(countriesCodes[d[0].index]+"_tooltip") != countriesCodes[d[0].index]+"_tooltip") {
                    countryName = _(countriesCodes[d[0].index]+"_tooltip");
                }
                var content = '<table class="bb-tooltip"><tbody>' +
                    '<tr><th style="background-color:black" colspan="2">' + countryName + '</th></tr>';
                const grouping = indicators[currentCategory].grouping;
                var originalData = arrayGrouped[d[0].index];
                for (var groupIndexTmp in d) {
                    var item = d[groupIndexTmp];
                    if (item.id != "undefined") {
                        var groupIndex = groups.indexOf(item.id);
                        var currentGroup = grouping.groups[groupIndex].code;
                        //console.log(currentSorting);
                        //console.log(currentGroup);
                        var code = item.code;
                        var value = roundValue(item.value);
                        
                       // console.log(code);
                       // var itemTmp = data.filter(function(el) {console.log(el); return el.Geo = code }); 
                       // console.log(itemTmp)
                        /*
                        if (arrayNotCorrected[countriesCodes[d[0].index] + "_" + groupIndex]) {
                            value = roundValue(arrayNotCorrected[countriesCodes[d[0].index] + "_" + groupIndex]);
                        }
                        */
                       //console.log(originalData);
                        if (currentGroup != currentSorting && originalData[currentGroup+"_UNTOUCHED"]) {
                            value = "Corrected";
                            value = roundValue(originalData[currentGroup+"_UNTOUCHED"]);
                        }
                        var legend = grouping.groups[groupIndex].legend ? grouping.groups[groupIndex].legend : grouping.groups[groupIndex].title;

                        if (value != 0) {
                            var strValue = value.toString();
                            strValue = strValue.replace(".", _("decimal_separator"));
                            content += '<tr class="bb-tooltip-name-data1"><td class="name"><span style="background-color:' + grouping.groups[groupIndex].color + '"></span>' + _(legend) + '</td><td class="value">' + strValue + ' %</td></tr>';

                        }


                    }
                }
                content += '</tbody></table>';
                return content;

            }
        },
        legend: {
            hide: legendHide,
            item: legendItems,
            contents: legendContent,
        },
        interaction: {
            inputType: {
                touch: {
                    preventDefault: true
                }
            }
        },
        color: color,
        bindto: "#chart",
        onrendered: function() {

            d3.selectAll('g.bb-axis-x .tick') //here's how you get all the nodes
                .each(function(d) {
                    // your update code here as it was in your example
                    //console.log(d3.select(this).selectAll("tspan").text())
                    if (d3.select(this).selectAll("tspan").text() == "") {
                        $(this).remove();
                        d3.select(".bb-event-rect-" + d).remove();
                        d3.selectAll(".bb-bar-0").style("height", "50px")

                    } else { // -6
                        d3.select(this).selectAll("text").attr("y", "10px")
                        d3.select(this).selectAll("line").remove();
                    }

                });
            d3.selectAll('rect.bb-event-rect') //here's how you get all the nodes
                .each(function(d) {
                    d3.select(this).attr("height", "8")
                });

            $("#bookmark-link, #chartInd").show();
            checkSortIcons(selectedSortProperty, selectedSortDirection);

            d3.selectAll("pattern").attr("id", function(d) {
                return $(this).attr("id2");
            })
            var code = selectedCountry;
            var countryFound = false;
            d3.selectAll('g.bb-axis.bb-axis-x .tick') //here's how you get all the nodes
                .each(function(d) {
                    // your update code here as it was in your example
                    if (d3.select(this).selectAll("tspan").text() == _(code)) {
                        d3.select(this).selectAll("text").attr("fill", "#E34A21");
                        d3.select(this).selectAll("text").attr("font-weight", "bold");
                        countryFound = true;
                    } else {
                        d3.select(this).selectAll("text").attr("fill", "black")
                        d3.select(this).selectAll("text").attr("font-weight", "regular")
                    }

                });
            if (countryFound == false && parent.displayChartAlert) {
                parent.displayChartAlert("noData", code);
            } else {
                //alert('Data not available');
            }
        },
    });
}

window.updateCountry = function(countryCode) {
    if (countryCode != "") {
        selectedCountry = countryCode;
        highlightCountry(chart, countryCode);
    }
}

function drawScatterLines() { 
  
    $(".dotLine").remove();

    var svg
    var lineFunction = d3.line()
      .x(function(d) { return d.x; })
      .y(function(d) { return d.y; })

    for (var i = 0; i < data.length; i++) {

        var iterator = 0;
        var xSaved = 0;
        var circleCoords = [];
        var line = d3.line()
        var nodes = d3.selectAll(".bb-circle-"+i)
        .each(function(d) {

            var item = d3.select(this);
            var visible = displayed.indexOf(d.id) !== -1;

            if (d.value != null && d.value != 0 && visible) {
                var xPadding = window.innerWidth < 600 ? 3 : 7;
                var yPadding = window.innerWidth < 600 ? 3 : 7;
                var cx = $(this).attr('cx') ? $(this).attr('cx') : parseFloat($(this).attr('x'))+xPadding;

                var cy = $(this).attr('cy') ? $(this).attr('cy') : parseFloat($(this).attr('y'))+yPadding;
                circleCoords.push({x:cx, y:cy});
            }
            if (indicators[currentCategory].removeZeroValue && d.value == 0) {
                this.remove();
            }
            if (d.id == "undefined" ) {
                this.remove();
            }
            iterator++;
        });

        svg = d3.selectAll("#chart svg .bb-chart-lines")

        var lineGraph = svg.append("path")
        .attr("d", lineFunction(circleCoords))
        .attr("class", "dotLine")
        .moveToBack();

    }
                
}

function highlightCountry(chart, code) {
    selectedCountry = code;
    var countryFound = false;
    var index = 0;

    d3.selectAll('g.bb-axis.bb-axis-x .tick') //here's how you get all the nodes
        .each(function(d) {
            // your update code here as it was in your example
            if (d3.select(this).selectAll("tspan").text() == _(code)) {
                d3.select(this).selectAll("text").attr("fill", "#E34A21");
                d3.select(this).selectAll("text").attr("font-weight", "bold");

                countryFound = true;
            } else {
                d3.select(this).selectAll("text").attr("fill", "black")
                d3.select(this).selectAll("text").attr("font-weight", "regular")
            }
            index++;
        });

    if (countryFound == false && parent) {
        parent.displayChartAlert("noData", code);
    } else {
        //alert('Data not available');
    }

    chart.load({
        rows: data
    });


}

function setcurrentSortingCS(newValue) {
    currentSorting = newValue;
}

function selectedSortPropertyCS(newValue) {
    selectedSortProperty = newValue;
}

function selectedSortDirectionCS(newValue) {
    selectedSortDirection = newValue;
}
export {
    processData,
    processDataForCategory,
    highlightCountry,
    indicatorClick,
    setcurrentSortingCS,
    changeParams,
    selectedSortPropertyCS,
    selectedSortDirectionCS,

    currentCategory,
    CHECKED_FA_HTML,
    UNCHECKED_FA_HTML,
    selectedSortProperty,
    selectedSortDirection,
    currentSorting,
    groups
};